import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import * as Api from "../lib/api";
import { AuthShell, Field } from "./LoginPage";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AcceptInvitePage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const { loginAs } = useAuth();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState(null);
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setErr("Missing invite token"); return; }
    Api.getInviteInfo(token)
      .then(setInfo)
      .catch(e => setErr(e?.response?.data?.detail || "Invite not found or expired"));
  }, [token]);

  async function submit(e) {
    e.preventDefault();
    if (pw.length < 8) { toast.error("Password must be ≥ 8 chars"); return; }
    setBusy(true);
    try {
      const d = await Api.acceptInvite({ token, password: pw });
      loginAs(d.access_token, d.user, d.team);
      toast.success("Welcome to the team");
      nav("/");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not accept invite");
    } finally { setBusy(false); }
  }

  if (err) return <AuthShell title="Invite Error" subtitle={err}><div className="text-white/60 text-sm">Ask your admin to re-send.</div></AuthShell>;
  if (!info) return <AuthShell title="Loading invite…" subtitle=""><div className="text-white/60">Loading…</div></AuthShell>;

  return (
    <AuthShell title="Accept Invite" subtitle={`Join ${info.team_name || "the team"}`}>
      <form onSubmit={submit} className="space-y-5" data-testid="invite-form">
        <div className="bg-black border-2 border-[#F26522] p-4">
          <div className="font-mono text-[10px] tracking-wider text-[#F26522] uppercase">Invited Email</div>
          <div className="font-mono text-base text-white mt-1" data-testid="invite-email-display">{info.email}</div>
        </div>
        <Field label="Choose a password (min 8 chars)" type="password" value={pw} onChange={setPw} testId="invite-password" required autoComplete="new-password" />
        <button type="submit" disabled={busy} data-testid="invite-submit"
          className="w-full h-16 bg-[#F26522] text-black font-heading font-black tracking-wider uppercase text-base flex items-center justify-center gap-2 hover:bg-[#FF7A2A] transition-colors disabled:opacity-60">
          {busy && <Loader2 className="w-5 h-5 animate-spin" />}
          Join Team
        </button>
      </form>
    </AuthShell>
  );
}
